import { Container, Row, Col } from 'react-bootstrap';
import { Carousel } from 'antd';
import styled from "styled-components"

import { Quote } from '../styled/BPSQuotes';

import '../GlobalStyle.css';

const BPSCarousel = styled.div`

.ant-carousel .slick-dots li button {
    background-color: #aaaaaa;
    display: block;
    height: 12px;
    width: 12px;
    border-radius: 12px;
    margin-top: 2rem;
}
`

const QuoteCarousel = () => {
    return (
        <>
            <Container fluid className='text-center py-5'>
                <Row className='justify-content-center'>
                    <Col xxl={4} lg={8}>
                        <BPSCarousel>
                            <Carousel autoplay effect='fade' speed={900}>
                                <div>
                                    <Quote>
                                        Two words: Absolutely excellent. I can't recommend them highly enough. You never have rebate issues when you work with Best Payment Solutions, because as soon as you explain a potential problem they solve it. If your company needs a trustworthy 3rd party to handle your rebate program - work with Best Payment Solutions. It's a no brainer.
                                        <div className='pt-4'>
                                            Alex
                                        </div>
                                        <div>
                                            SunPower
                                        </div>
                                    </Quote>
                                </div>
                                <div>
                                    <Quote>
                                        Best Payment Solutions makes our safety rewards program so much easier to administer and with virtual visa delivery the rewards are given almost in real-time.
                                        <div className='pt-4'>
                                            Dennis
                                        </div>
                                        <div>
                                            Champion Framing
                                        </div>
                                    </Quote>
                                </div>
                                <div>
                                    <Quote>
                                        Best Payment Solutions are a massive asset to our company - they've certainly made our lives easier after implementing their virtual visa program for our Truck Driver healthcare rewards program.
                                        <div className='pt-4'>
                                            Melanie
                                        </div>
                                        <div>
                                            Rolling Strong
                                        </div>
                                    </Quote>
                                </div>
                            </Carousel>
                        </BPSCarousel>
                    </Col>
                </Row>
            </Container >
        </>
    );
}

export default QuoteCarousel;